<template>
<h1 class="text-center">PixiPlugin</h1>
</template>

<script>
export default {
  name: "PixiPlugin"
}
</script>

<style scoped>

</style>